import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import {
  Button,
  Form,
  Dropdown,
  Checkbox,
  Tab,
  Input,
  TextArea,
  Divider,
  Message,
  Accordion,
  List,
} from "semantic-ui-react";
import { IoMdClose } from "react-icons/io";
import { toast } from "react-toastify";

import {
  Container,
  Content,
  Title,
  Error,
  UsersEmailListTitle,
  SelectedUsersEmailsListContainer,
  SelectedUsersEmailsListItem,
  SelectedUsersEmailsListItemIcon,
  SelectedUsersEmailsListEmptyContainer,
  SelectedUsersEmailsListEmptyText,
  FileInputLabel,
  FileInput,
  FileInputContainer,
  FileInputButtonContainer,
} from "./styles";
import swal from "sweetalert";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import DropdownAlunos from "../../../../components/Admin/DropdownAlunosMultiple";
import AlunosSelector from "../../../../components/Admin/AlunosSelector";
import { AlunoSearchInput } from "../../../../components/Admin/AlunoSearchInput";
import { RenderIf } from "../../../../components";
import Excel from "exceljs";

const actionOptions = [
  { key: "assistir", value: "assistir", text: "Assistir" },
  { key: "blog", value: "blog", text: "Blog" },
  { key: "tickets", value: "tickets", text: "Tickets" },
  { key: "link", value: "link", text: "Link" },
];

// const iconOptions = [
//   {
//     key: "presente",
//     value:
//       "https://files.voitto.com.br/icons/BirthdayTicketIcon.png",
//     text: "Presente",
//     image: {
//       src:
//         "https://files.voitto.com.br/icons/BirthdayTicketIcon.png",
//     },
//   },
//   {
//     key: "ticket",
//     value:
//       "https://files.voitto.com.br/ftp-files/assets/images/ticket_icon.png",
//     text: "Ticket",
//     image: {
//       src:
//         "https://files.voitto.com.br/ftp-files/assets/images/ticket_icon.png",
//     },
//   },
// ];

function UsersEmailListBySearch({ onAddEmail }) {
  return (
    <AlunoSearchInput
      hideLabel
      handleChange={({ email }) => onAddEmail(email)}
    />
  );
}

function UsersEmailListByInput({ onAddMultipleEmails = () => {} }) {
  const [value, setValue] = useState("");

  const onChangeInput = (e) => {
    setValue(e?.target?.value);
  };

  const onSubmit = (e) => {
    const delimiter = value?.includes(",") ? "," : ";";
    const emailList = value?.split(delimiter);
    const filteredEmailList = emailList?.filter((email) => email?.length > 0);

    onAddMultipleEmails(filteredEmailList);
  };

  const isValidInput = value?.length > 0;

  return (
    <>
      <TextArea
        placeholder="Cole os emails separados por (,) ou (;)"
        fluid
        onChange={onChangeInput}
        value={value}
      />
      <Divider hidden />
      <FileInputButtonContainer>
        <Button
          floated="right"
          disabled={!isValidInput}
          color="green"
          onClick={onSubmit}
        >
          Adicionar emails
        </Button>
      </FileInputButtonContainer>
    </>
  );
}

const getValueFromExcelType = (cell) => {
  switch (cell?.type) {
    case Excel.ValueType.Null:
    case Excel.ValueType.Number:
    case Excel.ValueType.String:
    case Excel.ValueType.Date:
    case Excel.ValueType.Boolean: {
      return cell?.value;
    }
    case Excel.ValueType.Hyperlink: {
      return cell?.value?.text;
    }
    case Excel.ValueType.Formula: {
      return cell?.value?.result;
    }
    case Excel.ValueType.Error: {
      return null;
    }
    default: {
      return null;
    }
  }
};

function UsersEmailListByImport({ onAddMultipleEmails = () => {} }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const onChangeSelectedFile = (e) => {
    const [file] = e?.target?.files;

    setSelectedFile(file);
  };

  const onSubmit = async () => {
    setIsLoading(true);
    const workbook = new Excel.Workbook();

    await workbook.xlsx.load(selectedFile);
    const worksheet = workbook.getWorksheet(1);

    const firstColumn = worksheet.getColumn(1);
    let emailList = [];

    firstColumn.eachCell((cell) => {
      const value = getValueFromExcelType(cell);

      emailList.push(value);
    });

    emailList = emailList?.filter(Boolean);

    onAddMultipleEmails(emailList);
    setIsLoading(false);
  };

  return (
    <>
      <FileInputContainer>
        <FileInputLabel>
          {"Selecione o arquivo (*.xlsx, *.xls)"}
          <FileInput
            accept=".xlsx, .xls"
            type="file"
            onChange={onChangeSelectedFile}
          />
        </FileInputLabel>
      </FileInputContainer>
      <FileInputButtonContainer>
        <Button
          loading={isLoading}
          color="green"
          type="button"
          onClick={onSubmit}
          disabled={!selectedFile}
        >
          Carregar emails
        </Button>
      </FileInputButtonContainer>
      <Message>
        <Message.Header>Sobre arquivos importados</Message.Header>
        <Accordion styled fluid>
          <Accordion.Title active>Planilhas</Accordion.Title>
          <Accordion.Content active>
            <List bulleted>
              <List.Item>
                Os emails devem estar em uma única coluna e na primeira coluna
              </List.Item>
            </List>
          </Accordion.Content>
        </Accordion>
      </Message>
    </>
  );
}

function SelectedUsersEmailsList({
  selectedEmails = [],
  onRemoveEmail = () => {},
}) {
  if (selectedEmails?.length === 0) {
    return (
      <SelectedUsersEmailsListEmptyContainer>
        <SelectedUsersEmailsListEmptyText>
          Nenhum email selecionado
        </SelectedUsersEmailsListEmptyText>
      </SelectedUsersEmailsListEmptyContainer>
    );
  }

  return (
    <SelectedUsersEmailsListContainer>
      {selectedEmails?.map((email) => {
        return (
          <SelectedUsersEmailsListItem>
            {email}
            <SelectedUsersEmailsListItemIcon
              type="button"
              onClick={() => onRemoveEmail(email)}
            >
              <IoMdClose size="1.2em" />
            </SelectedUsersEmailsListItemIcon>
          </SelectedUsersEmailsListItem>
        );
      })}
    </SelectedUsersEmailsListContainer>
  );
}

function UsersEmailList({ onChangeEmailList = () => {} }) {
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [submitCounter, setSubmitCounter] = useState(0);

  const onAddEmail = (email) => {
    if (selectedEmails?.includes(email)) {
      toast.info("Email já adicionado na lista", { autoClose: 2000 });
      return;
    }

    setSelectedEmails((prev) => {
      const newEmails = [...prev, email];
      onChangeEmailList(newEmails);

      return newEmails;
    });
    setSubmitCounter((prev) => prev + 1);
  };

  const onAddMultipleEmails = (emails = []) => {
    setSelectedEmails((prev) => {
      const newEmails = [...new Set([...prev, ...emails])];
      onChangeEmailList(newEmails);

      return newEmails;
    });
    setSubmitCounter((prev) => prev + 1);
  };

  const onRemoveEmail = (email) => {
    setSelectedEmails((prev) => {
      const newEmails = prev?.filter((prevEmail) => prevEmail !== email);
      onChangeEmailList(newEmails);

      return newEmails;
    });
  };

  const onRemoveAllEmails = async () => {
    const response = await swal({
      title: "Deseja remover os emails?",
      text: "Deseja remover todos os emails da lista. Essa ação é irreversivel",
      dangerMode: true,
      closeOnClickOutside: true,
      closeOnEsc: true,
      icon: "info",
      buttons: {
        cancel: "Cancelar",
        remove: {
          text: "Remover",
          value: "remove",
          visible: true,
        },
      },
    });

    if (response === "remove") {
      setSelectedEmails([]);
      onChangeEmailList([]);
    }
  };

  return (
    <>
      <UsersEmailListTitle>Selecionar alunos</UsersEmailListTitle>
      <Tab
        panes={[
          {
            menuItem: "Buscar",
            render: () => (
              <Tab.Pane>
                <UsersEmailListBySearch
                  key={`search-${submitCounter}`}
                  onAddEmail={onAddEmail}
                />
              </Tab.Pane>
            ),
          },
          {
            menuItem: "Lista de emails",
            render: () => (
              <Tab.Pane>
                <UsersEmailListByInput
                  key={`input-${submitCounter}`}
                  onAddMultipleEmails={onAddMultipleEmails}
                />
              </Tab.Pane>
            ),
          },
          {
            menuItem: "Importar",
            render: () => (
              <Tab.Pane>
                <UsersEmailListByImport
                  key={`file-${submitCounter}`}
                  onAddMultipleEmails={onAddMultipleEmails}
                />
              </Tab.Pane>
            ),
          },
        ]}
      />
      <SelectedUsersEmailsList
        selectedEmails={selectedEmails}
        onRemoveEmail={onRemoveEmail}
      />
      <RenderIf isTrue={selectedEmails?.length > 0}>
        <Button
          floated="right"
          type="button"
          color="red"
          onClick={onRemoveAllEmails}
        >
          Remover Emails
        </Button>
      </RenderIf>
    </>
  );
}

const PushNotificacao = () => {
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [message, setMessage] = useState("");
  const [action, setAction] = useState("");
  const [actionData, setActionData] = useState("");
  const [idAluno, setIdAluno] = useState([]);
  const [icon, setIcon] = useState("");
  const [image, setImage] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [allAlunos, setAllAlunos] = useState(false);
  const [expirationDays, setExpirationDays] = useState(7);
  const [emailList, setEmailList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isAll, setIsAll] = useState(false);

  const handleImage = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setIsUpdate(true);
    }
  };

  const uploadImage = async (name) => {
    const data = new FormData();
    data.append("file", image);
    data.append("nome", name);
    data.append("path", "icons/notifications");

    return await api
      .post("/upload", data)
      .then((res) => res.data.url)
      .catch((err) => console.error(err));
  };

  const handleIcon = async () => {
    if (isUpdate) {
      const date = new Date().getTime();
      const nameImage = `${image.name.split(".")[0]}-${date}`;
      return await uploadImage(nameImage);
    }

    return icon;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!message || !actionData) {
      swal({
        title: "Preencha todos os campos",
        icon: "error",
      });

      setIsLoading(false);
      return;
    }

    if (emailList?.length === 0 && !allAlunos) {
      const sendWithoutUser = await swal(
        "Nanhum aluno selecionado",
        "Nenhum aluno foi selecionado para o envio da notificação. Deseja criar sem nenhum aluno selecionado?",
        "warning",
        {
          buttons: ["Cancelar", "Criar sem aluno"],
        }
      );

      if (!sendWithoutUser) {
        setIsLoading(false);
        return;
      }
    }

    if (allAlunos) {
      const sendToAll = await swal(
        "Tem certeza?",
        "Deseja enviar essa notificação para todos os alunos",
        "warning",
        {
          buttons: ["Não enviar", "Enviar"],
        }
      );

      if (!sendToAll) {
        setIsLoading(false);
        return;
      }
    }

    const destiny = JSON.stringify([`${idAluno}`]);

    const data = {
      title: "--",
      subtitle: "--",
      message,
      action: "link",
      actionData,
      expirationDays,
      ticker: "",
      statusReaded: "[]",
      statusReceived: "[]",
      statusCleaned: "[]",
      destiny: destiny.replace(",", `\",\"`),
      emails: emailList,
      icon: JSON.stringify({
        type: "image",
        value:
          "https://files.voitto.com.br/ftp-files/assets/images/ticket_icon.png",
      }),
    };

    await api
      .post(`admin/notificacoes/push?isAll=${isAll}`, data, {
        headers: {
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
        },
      })
      .then(() => {
        swal({
          title: "Notificação criado com sucesso",
          icon: "success",
        }).then(() => {
          if (window) {
            window.location.reload();
          }
        });
      })
      .catch((err) => {
        console.error(err);
        swal("Algo deu errado na criação da notificação", "", "error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    // Se for selecionado para todos os alunos, resetar a lista de emails
    if (allAlunos && emailList?.length > 0) {
      setEmailList([]);
    }
  }, [allAlunos]);

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Criar Notificação</Title>
          <Form onSubmit={handleSubmit}>
            <Form.Input
              label="Mensagem ao Aluno"
              placeholder="Mensagem que aparecerá ao usuário"
              value={message}
              onChange={(e) => {
                // setTitle(e.target.value);
                setMessage(e.target.value);
              }}
            />
            <Form.Group>
              {/* <Form.Input
              label="Subtitulo da Mensagem"
              placeholder="Subtitulo da Mensagem"
              value={subtitle}
              onChange={(e) => {
                setSubtitle(e.target.value);
              }}
            /> */}

              {/* <Form.Input
              label="Conteúdo da mensagem"
              placeholder="Conteúdo da Mensagem"
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
              }}
            /> */}
              <Form.Input
                label="Duração da notificação (em dias)"
                placeholder="Duração da notificação"
                type="number"
                min={1}
                value={expirationDays}
                onChange={(e) => setExpirationDays(parseInt(e.target.value))}
              />
              {/* <Form.Field>
                <label>Selecione a ação</label>
                <Dropdown
                  placeholder="Ação"
                  fluid
                  selection
                  clearable
                  options={actionOptions}
                  onChange={(e, data) => setAction(data.value)}
                  value={action}
                />
              </Form.Field> */}

              <Form.Input
                label="Adicione o link"
                placeholder="https://voitto.com.br/voitto-pro"
                value={actionData}
                onChange={(e) => {
                  setActionData(e.target.value);
                }}
              />
            </Form.Group>
            <Checkbox
              value={allAlunos}
              label="Enviar para todos os Alunos?"
              onChange={() => {
                setAllAlunos(!allAlunos);
                setIsAll((prev) => !prev);
              }}
            />
            <RenderIf isTrue={!allAlunos}>
              <UsersEmailList onChangeEmailList={setEmailList} />
            </RenderIf>

            {/* <Form.Field>
              <label>Selecionar ícone</label>
              <Dropdown
                placeholder="Ícones"
                fluid
                selection
                clearable
                options={iconOptions}
                onChange={(e, data) => setIcon(data.value)}
                disabled={isUpdate}
              />
            </Form.Field> */}

            {/* <label>Upload ícone</label>
            <Form.Field>
              <Form.Input type="file" onChange={handleImage} />
            </Form.Field> */}

            <Button loading={isLoading} primary type="submit">
              Criar
            </Button>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default PushNotificacao;
